import React, { useState } from 'react';
import { Select } from '@amzn/awsui-components-console';

export default class SelectGroup extends React.Component {
    /**
     * package select group
     * @param props
     * @props onChange (required): update group by user selection
     * @props selectedOption (required): selected group
     * @props fetchOptions (required): the API call to get options for the select component
     */
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            status: 'pending',
        };
    }

    componentDidMount = () => {
        this._isMounted = true;
        this.fetchData();
    };
    componentWillUnmount() {
        this._isMounted = false;
    }
    fetchData = async () => {
        try {
            if (this.state.options.length === 0) {
                this.setLoading();
                const response = await this.props.fetchOptions();
                const options = response.map((item) => ({ label: item.name, value: item.name, description: item.id }));
                this.setFinished(options);
            }
        } catch (error) {
            console.error(error);
            this.setError();
        }
    };
    setLoading = () => {
        if (this._isMounted)
            this.setState({
                status: 'loading',
                options: [],
            });
    };
    setFinished = (packages) => {
        if (this._isMounted)
            this.setState({
                status: 'finished',
                options: packages,
            });
    };
    setError = () => {
        if (this._isMounted)
            this.setState({
                status: 'error',
                options: [],
            });
    };
    handleLoadItems = ({ detail: { filteringText, firstPage, samePage } }) => {
        if (this.state.status === 'error' && samePage) {
            this.fetchData();
        }
    };
    render() {
        return (
            <Select
                selectedOption={this.props.selectedOption}
                placeholder={this.props.placeholder}
                loadingText={this.props.loadingText}
                errorText={this.props.errorText}
                recoveryText="Retry"
                empty="No group found"
                filteringType="auto"
                virtualScroll={true}
                statusType={this.state.status}
                options={this.state.options}
                onChange={this.props.onChange}
                onLoadItems={this.handleLoadItems}
            />
        );
    }
}
